import { InsurancePolicy } from '@/interfaces';
import { SelfServiceService } from '@/services/store';

export const getCurrentPolicy = (insurancePolicies: InsurancePolicy[], testPolicyNumber?: string): InsurancePolicy => {
  if (!insurancePolicies) return {} as InsurancePolicy;
  const queryString = window.location.search.toLowerCase();
  const urlParams = new URLSearchParams(queryString);
  const policyNumber = urlParams.get('policynumber');

  const usePolicyNumber = (policyNumber?.length ?? 0) > 0 ? policyNumber : testPolicyNumber;

  const tempPolicy = insurancePolicies.find((x) => x.policyNumber.toLowerCase() === usePolicyNumber?.toLowerCase());
  return tempPolicy as InsurancePolicy;
};

export const requestCoc = async (policyNumber: string) => {
  try {
    await SelfServiceService.requestCoCDocument(policyNumber);
  } catch (error) {
    return 'coc-error';
  }
};

export const downloadDocument = async (documentStorageId: string) => {
  try {
    await SelfServiceService.getDownloadDocument(documentStorageId);
  } catch (error) {
    console.error('err', error);
    return 'coi-error';
  }
};

export const downloadCoc = async (certOfCurrencyDocumentId: string) => {
  await SelfServiceService.getDownloadCoC(certOfCurrencyDocumentId);
};
